"use strict";

var resolveException = require("../lib/resolve-exception")
  , is               = require("./is");

module.exports = function (value/*, options*/) {
	if (is(value)) return value;
	return resolveException(value, "Cannot use %v", arguments[1]);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/type/value/ensure.js
// module id = 213
// module chunks = 0